import React from 'react';
import './TitleHeader.css'

export function TitleHeader({ title }) {
  return (
    <div className='TitleHeaderContainer'>
      {title}
    </div>
  )
}